export const BACKEND_REQUEST_SENT_EVENT = 'backendRequestSent';
export const ACTIVE_ANALYTICS_ENGAGEMENT_EVENT = 'activeAnalyticsEngagement';

let lastBackendRequestSentAt = Date.now();
let lastActiveAnalyticsEngagementAt = 0;

export function markBackendRequestSent(): void {
  lastBackendRequestSentAt = Date.now();
  document.dispatchEvent(new CustomEvent(BACKEND_REQUEST_SENT_EVENT, {
    detail: { sentAt: lastBackendRequestSentAt }
  }));
}

export function getLastBackendRequestSentAt(): number {
  return lastBackendRequestSentAt;
}

export function markActiveAnalyticsEngagement(): void {
  lastActiveAnalyticsEngagementAt = Date.now();
  document.dispatchEvent(new CustomEvent(ACTIVE_ANALYTICS_ENGAGEMENT_EVENT, {
    detail: { sentAt: lastActiveAnalyticsEngagementAt }
  }));
}

export function getLastActiveAnalyticsEngagementAt(): number {
  return lastActiveAnalyticsEngagementAt;
}
